import { useEffect, useState } from "react";
import debounce from "lodash/debounce";

type WindowSize = {
  innerHeight: number;
  innerWidth: number;
  outerHeight: number;
  outerWidth: number;
};

//Based on a laptop computer screen.
export const fallbackWindowSize: WindowSize = {
  innerHeight: 736,
  innerWidth: 1440,
  outerHeight: 847,
  outerWidth: 1440,
};

const getSize = (): WindowSize => {
  try {
    return {
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth,
      outerHeight: window.outerHeight,
      outerWidth: window.outerWidth,
    };
  } catch {
    return fallbackWindowSize;
  }
};

export const useWindowSize = (): WindowSize => {
  const [windowSize, setWindowSize] = useState<WindowSize>(getSize());

  const eventHandler = () => {
    setWindowSize(getSize());
  };
  const debouncedHandler = debounce(eventHandler, 50);

  useEffect(
    () => {
      window.addEventListener("resize", debouncedHandler);

      return () => {
        debouncedHandler.cancel();
        window.removeEventListener("resize", debouncedHandler);
      };
    },
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    []
  );

  return windowSize;
};
